import {useNavigate, createSearchParams} from 'react-router-dom'


export default function useSearchNavigate() {
    const nav = useNavigate()
    return (path:string, params:any) => {
        nav({pathname: path, search: `?${createSearchParams(params)}`})
    }
}